import { Heading, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, VStack } from "@chakra-ui/react";
import { format } from "date-fns";
import { sortBy } from "ramda";
import { match } from "ts-pattern";
import {
  DashboardData,
  SampleRecord,
  getReferenceLimitsExceedingSamples,
  hasReferenceLimits,
} from "../../types/dashboardData";

export function ReferenceLimitsTable({ dashboardData, analyte }: { dashboardData: DashboardData; analyte: string }) {
  return match(hasReferenceLimits(dashboardData))
    .with(false, () => <Text color="red">Reference Limit not found for {analyte}</Text>)
    .otherwise(() => (
      <VStack alignItems={"flex-start"} gap={4}>
        <Heading size="md">Reference Limits</Heading>
        <TableContainer overflowY="auto">
          <Table variant="striped" size="sm">
            <Thead>
              <Tr>
                <Th>Site</Th>
                <Th>Date</Th>
                <Th>Analyte</Th>
                <Th>Result</Th>
                <Th>Unit</Th>
                <Th>Reference Limit</Th>
              </Tr>
            </Thead>
            <Tbody>
              <ReferenceLimitRows dashboardData={dashboardData} analyte={analyte} />
            </Tbody>
          </Table>
        </TableContainer>
      </VStack>
    ));
}

export function ReferenceLimitRows({ dashboardData, analyte }: { dashboardData: DashboardData; analyte: string }) {
  const samples = sortBy(([record]) => record.sampleDate, getReferenceLimitsExceedingSamples(dashboardData));
  return (
    <>
      {samples.length === 0 ? (
        <Tr>
          <Td colSpan={6}>none</Td>
        </Tr>
      ) : (
        samples.map(([sampleRecord, limit]) => (
          <ReferenceLimitRow
            key={sampleRecord.siteName + sampleRecord.sampleDate.toISOString() + limit}
            sampleRecord={sampleRecord}
            analyte={analyte}
            unit={dashboardData.unit || ""}
            limit={limit}
          />
        ))
      )}
    </>
  );
}

export function ReferenceLimitRow({
  sampleRecord,
  analyte,
  unit,
  limit,
}: {
  sampleRecord: SampleRecord;
  analyte: string;
  unit: string;
  limit: number;
}) {
  return (
    <Tr>
      <Td>{sampleRecord.siteName}</Td>
      <Td>{format(sampleRecord.sampleDate, "yyyy-MM-dd")}</Td>
      <Td>{analyte}</Td>
      <Td>{sampleRecord.measurementResult}</Td>
      <Td>{unit}</Td>
      <Td>{limit}</Td>
    </Tr>
  );
}
